import React from 'react';
import { generatePath, useHistory, useParams } from 'react-router-dom';

import Page from '../Setting/Page';
import { routes } from 'flow/types/routes';
import { PbxParams } from 'flow/types/Params';
import { TelephoneNumber } from 'flow/types/TelephoneNumber';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { updateQueueProfile } from 'flow/actions/pbx-actions';

import { Map } from 'immutable';
import { TypedMap } from 'flow/types/TypedMap';
import RedirectPhoneNumberPicker from '../settings/RedirectPhoneNumberPicker';

const PbxWelcomeMessageProfileRedirect = () => {
    const history = useHistory();
    const dispatch = useAppDispatch();

    const { entityKey, profileKey } = useParams<PbxParams>();

    const queue = useAppSelector((state) =>
        state.pbx.getIn(['queues', entityKey], Map()),
    );

    const handleSetRedirectNumber = (numberDTO: TypedMap<TelephoneNumber>) => {
        const profile = queue
            ?.get('profiles')
            .filter((profile: any) => profile.get('key') === profileKey)
            .first();
        const newProfile = profile.setIn(
            ['callForwarding', 'redirect'],
            numberDTO,
        );

        dispatch(updateQueueProfile(entityKey, profileKey, newProfile));
        history.push(
            generatePath(
                routes[
                    'pbx.queues.entityKey.settings.welcomemessage.profileKey'
                ],
                {
                    entityKey,
                    profileKey,
                },
            ),
        );
    };

    return (
        <Page
            header="pbx.closed"
            onClickBack={() =>
                history.push(
                    generatePath(
                        routes[
                            'pbx.queues.entityKey.settings.welcomemessage.profileKey'
                        ],
                        {
                            entityKey,
                            profileKey,
                        },
                    ),
                )
            }
        >
            <RedirectPhoneNumberPicker handleSelect={handleSetRedirectNumber} />
        </Page>
    );
};

export default PbxWelcomeMessageProfileRedirect;
